import React, { useState, useRef } from "react";
import { Form, Button, Card, Spinner, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom'; 
import Swal from 'sweetalert2';
import { api } from '../../services/api';
import logoSmall from './../../comum/assets/arbor.png';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from '../../comum/Footer/index.jsx';
import { FaUserCheck, FaIdCard } from 'react-icons/fa';
import './index.css';

function Validacaousr() {
  const navigate = useNavigate();
  const { tipo, validacao } = useParams();  
  const [chapa, setChapa] = useState('');
  const [loading, setLoading] = useState(false);

  const ValidaUsuario = async (e) => {
    if (e) e.preventDefault();

    if (!chapa.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Por favor, informe a matrícula.',
        confirmButtonColor: '#991b1b'
      });
      return;
    }

    setLoading(true);

    try {
      const response = await api.get(`/usuario/validacao/${tipo}/${chapa}/${validacao}`);
      const { erro, retorno } = response.data;

      localStorage.setItem("logado", erro === 'S' ? "N" : "S");

      if (erro === 'S') {
        Swal.fire({
          icon: 'error',
          title: 'Falha na Validação',
          text: retorno || 'Não foi possível validar o utilizador.',
          confirmButtonColor: '#991b1b'
        });
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: retorno || 'Utilizador validado com sucesso!',
          confirmButtonColor: '#991b1b',
          confirmButtonText: 'Continuar'
        }).then(() => {
          navigate('/');
        });
      }
    } catch (err) {
      console.error(err);
      localStorage.setItem("logado", "N");
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Ocorreu um erro ao comunicar com o servidor.',
        confirmButtonColor: '#991b1b'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <Menu /> 

      <Container className="flex-grow-1 d-flex align-items-center justify-content-center py-5" style={{ marginTop: '60px' }}>
        <Card className="border-0 shadow-lg rounded-4 overflow-hidden w-100" style={{ maxWidth: '400px' }}>
          
          {/* TOPO VERMELHO BORDÔ PADRÃO */}
          <div 
            className="p-4 text-center text-white" 
            style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
          >
            <img className="mb-2 img-logo-valida" src={logoSmall} alt="Arbor Logo" />
            <h5 className="fw-bold mb-0 d-flex align-items-center justify-content-center gap-2">
              <FaUserCheck /> Validação de Acesso
            </h5>
          </div>

          <Card.Body className="p-4 bg-white">
            <Form onSubmit={ValidaUsuario}>
              <Form.Group className="mb-4">
                <Form.Label className="extra-small fw-bold text-muted d-flex align-items-center gap-1">
                  <FaIdCard className="text-danger" /> MATRÍCULA
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Introduza a sua matrícula"
                  value={chapa}
                  onChange={(e) => setChapa(e.target.value)}
                  className="form-control-lg rounded-3 fs-6"
                  autoFocus
                />
              </Form.Group>

              <Button 
                type="submit" 
                className="w-100 py-2.5 fw-bold border-0 rounded-3 text-white shadow-sm d-flex align-items-center justify-content-center gap-2"
                style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Confirmar"}
              </Button>
            </Form>

            <div className="text-center mt-4 pt-3 border-top">
              <small className="text-muted extra-small">
                &copy; {new Date().getFullYear()} Desenvolvido por Floresta Comércio e Indústria SA
              </small>
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Footer />
    </div>
  );
}

export default Validacaousr;